











import { Component, Vue } from 'vue-property-decorator';
import { stAdminApi } from '@/services/st-api';
import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';
import StBadge from '@/components/basic/StBadge.vue';

@Component({
  components: { StBadge, StTabs, AccountSettingsInvoice },
})
export default class BambooHr extends Vue {
  result: string = '';

  async sync() {
    this.result = 'lade...';
    this.result = await stAdminApi.syncBambooHr();
  }

  async calc() {
    this.result = 'rechne...';
    try {
      await stAdminApi.calculateAll();
    } catch (e)
    {
      this.result = e;
    }

    this.result = 'ok';
  }
}
